// Currently we are only supporting 1 phone formats: US. If we
// expand formates we will have to build more significat enum logic, but this
// sets up the props interface to be extensible to that.
// Todo: implement international phone formats
export const countryBasePlaceholder = {
    US: 'XXX - XXX - XXXX',
};
export const countryPattern = {
    US: '[0-9]{3} - [0-9]{3} - [0-9]{4}',
};
export const countryMaxLength = {
    US: 16,
};
export const countryRegex = {
    US: /([0-9]{3})([0-9]{0,3})([0-9]{0,4})/g,
};
export const countryReplacer = {
    // @ts-ignore 2322
    US: (match, $1, $2, $3) => `${$1} - ${$2.length === 3 ? `${$2} - ${$3}` : $2}`,
};
export const getFormattedValue = ({ country, value, }) => (countryRegex[country]
    ? (value
        .replace(/[^0-9]/gi, '')
        .replace(countryRegex[country], countryReplacer[country]))
    : value);
export const handleChange = (props, event) => {
    const { country, } = props;
    const maxLength = countryMaxLength[country] || 32;
    const { target, } = event;
    let { value, } = target;
    // No phone entered, non character key pressed
    if (value.length <= props.value.length) {
        props.onChange(event);
        return;
    }
    // max length reached. do nothing.
    if (value.length > maxLength) {
        return;
    }
    // replace US number to XXX - XXX - XXXX format
    value = getFormattedValue({
        country,
        value,
    });
    event.target.value = value;
    props.onChange(event);
};
